'use client';

import { useRouter } from 'next/navigation';
import { useCallback } from 'react';

import { useContextTabsContext } from '../context/ContextTabsContext';

/** Returns Back behavior scoped to the active Context Tab when available. */
export function useContextTabBack(fallback?: string) {
  const router = useRouter();
  const context = useContextTabsContext();
  const navigateBack = context?.navigateBack;

  return useCallback(() => {
    if (navigateBack) navigateBack(fallback);
    else router.back();
  }, [fallback, navigateBack, router]);
}
